import AnchorLink from '../../src/legacy/AnchorLink.tsx';
export default AnchorLink;
